import OptionalInputs from "./FieldOptionalInputs";

export const FieldOptionalInputs = OptionalInputs;

export default FieldOptionalInputs;
